import React, {useMemo} from 'react';
import FormInput from '../FormInput';
import YesNoQuestion from './YesNoQuestion';
import OpenTextQuestion from './OpenTextQuestion';
import ChoiceQuestion from './ChoiceQuestion';
import RichTextQuestion from './RichTextQuestion';
import DateQuestion from './DateQuestion';
import NumberQuestion from './NumberQuestion';
import SmartTextQuestion from './SmartTextQuestion';
import SectionSeparator from './SectionSeparator';
import VStack from '../Layout/VStack';
import {QuestionTypes} from '../../../Configs/DatabaseConsts';

const QuestionRenderer = ({question, onChange, error, disabled}) => {
    const QuestionInput = useMemo(() => ({
        [QuestionTypes.YES_NO]: YesNoQuestion,
        [QuestionTypes.YES_NO_ADV]: YesNoQuestion,
        [QuestionTypes.OPEN]: OpenTextQuestion,
        [QuestionTypes.MULTIPLE_CHOICE]: ChoiceQuestion,
        [QuestionTypes.RICH_TEXT]: RichTextQuestion,
        [QuestionTypes.DATE]: DateQuestion,
        [QuestionTypes.NUMBER]: NumberQuestion,
        [QuestionTypes.SMART_TEXT]: SmartTextQuestion,
    }[question.type]), [question.type]);
    const answerKey = question.type === QuestionTypes.MULTIPLE_CHOICE && Number(question.multi_choice) ? 'checked_array' : 'user_answer';

    if (question.type === QuestionTypes.SECTION_SEPARATOR) return <VStack mb={'1rem'}><SectionSeparator title={question.question} /></VStack>;

    if (!QuestionInput) return null;

    return (
        <FormInput width="100%" label={question.question} required={!!Number(question.required)} error={error}>
            <QuestionInput question={question} value={question[answerKey]} onChange={(answer, questionOverride) => onChange({...question, ...questionOverride, [answerKey]: answer})} error={error} disabled={disabled} />
        </FormInput>
    );
};

export default QuestionRenderer;
